var e=(e,a)=>{a.forEach(a=>e.add(a))};export{e as default};